import { createSlice } from "@reduxjs/toolkit";

export const activeCardSlice = createSlice({
  name: "active-card",
  initialState: {
    isLoading: false,
    isError: false,
    activeCardData: [],
    message: "",
  },
  reducers: {
    onPostActiveCard: (state) => {
      return {
        ...state,
        isPostLoading: true,
        activeCardData: [],
      };
    },

    onPostActiveCardSuccess: (state, { payload }) => {
      const { postData = [], message = "", status_code="200" } = payload;
      return {
        ...state,
        isPostLoading: false,
        activeCardData: postData,
        postMessage:message,
        post_status_code:status_code,
      };
    },

    onPostActiveCardError: (state, { payload }) => {
      const { postData = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        activeCardData: postData,
        postMessage:message,
        post_status_code:status_code,
        isPostLoading: false,
      };
    },
    onPostActiveCardReset: (state) => {
      return {
        ...state,
        activeCardData: [],
        postMessage:"",
        post_status_code:null
      };
    },
  }
});

export const {
  onPostActiveCard,
  onPostActiveCardSuccess,
  onPostActiveCardError,
  onPostActiveCardReset
} = activeCardSlice.actions;

export default activeCardSlice.reducer;
